import BaseEntity from '../base/BaseEntity.model';
import TramiteBeneficiarioContent from './content/tramiteBeneficiarioContent.model';
import TramiteBeneficiarioDocumento from './tramiteBeneficiarioDocumento.model';
import NameValue from '../nameValue.model';
import Beneficiario from '../beneficiario/beneficiario.model';
import Persona from '../persona/persona.model';
import TipoTramite from '../tipoTramite';

export default class TramiteBeneficiario extends BaseEntity {
  //  public psWeb?: boolean;
   // public psOnline?: boolean;
   // public psMobile?: boolean;
    public numeroTramite?: string;
    public tipoTramiteId?: number;
    public personaId?: number;
    public beneficiarioId?: number;
    public contentId?: number;
    public content?: TramiteBeneficiarioContent;
    public documentos: TramiteBeneficiarioDocumento[];
    public tipoTramite?: TipoTramite;
    public persona?: Persona;
    public origen?: NameValue;
    public estado?: NameValue;
    public beneficiario?: Beneficiario;
    public prioridad?: NameValue;
    public asignadoId?: NameValue;
    public motivoRechazo?: string;

    
    constructor(){
        super();
    //    this.psWeb = undefined;
     //   this.psOnline = undefined;
     //   this.psMobile = undefined;
        this.numeroTramite = undefined;
        this.tipoTramiteId = undefined;
        this.contentId = undefined;
        this.content = undefined;
        this.personaId = undefined;
        this.beneficiarioId = undefined;
        this.documentos = [];
    }
}